import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import useBrandName from '@/hooks/use-brand-name';
import ApplicationImg from '@/assets/images/avantages/certimat_espace_assure.png'
import LogosImg from '@/assets/images/avantages/logo_certimat.webp'

const Certimat = () => {
    const brandName = useBrandName();
    return (
        <div className="mt-6">
            <Card>
                <CardContent className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                        <div className="md:col-span-4">
                            <img src={ApplicationImg} alt="Certimat" className="w-full rounded-lg" />
                        </div>
                        <div className="md:col-span-8">
                            <img src={LogosImg} alt="Logos Certimat" className="max-w-[300px] w-full" />
                            <h3 className="text-primary font-bold mt-6 text-lg">
                                Avec Certimat et {brandName}, facilitez vos démarches administratives
                            </h3>
                            <p className="mt-6 text-muted-foreground">
                                Grâce à notre partenariat avec Certimat, faire la demande de votre nouvelle carte grise devient beaucoup plus simple. Depuis notre <strong className="text-foreground">parcours de souscription, votre espace client ou certains e-mails {brandName}</strong>, vous pourrez désormais accéder directement à une interface dédiée, proposée par Certimat, pour faire votre demande de carte grise en tout sécurité et en quelques clics.
                            </p>

                            <p className="mt-6 font-semibold">Comment en bénéficier ?</p>
                            <ol className="mt-2 space-y-2 text-sm text-muted-foreground list-decimal list-inside">
                                <li><a href="https://certimat.fr/prescripteurs" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" aria-label="Accéder à l'espace Certimat">Cliquez ici</a> pour accéder à l'espace Certimat.</li>
                                <li>Identifiez-vous avec votre adresse email {brandName}.</li>
                                <li>Suivez les instructions pour réaliser votre démarche.</li>
                            </ol>

                            <Button asChild className="mt-6 cursor-pointer">
                                <a target="_blank" rel="noopener noreferrer" href="https://www.april-moto.com/mettez-votre-carte-grise-a-jour-en-ligne-et-simplement-grace-a-april-moto/" className="no-underline text-white" aria-label="En savoir plus sur Certimat">
                                    <ExternalLink className="w-4 h-4" aria-hidden="true" />
                                    En savoir plus
                                </a>
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default Certimat;
